// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const Root = styled.div`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 0.5rem;
  /* text-disabled fails AA on white; opaque secondary stays >= 4.5:1. */
  color: var(--mb-color-text-secondary-opaque);
`;

export const ShortMessage = styled.span`
  font-weight: bold;
  font-size: 1.12em;
  /* Measured empty-state label (div > span[2], 1.12em / weight 700). */
  color: var(--mb-color-text-secondary-opaque);
`;
